<template>
  <div class="ls-box-filter ls-no-margin-bottom">
    <form class="ls-form ls-form-horizontal row">
      <fieldset>
        <div class="col-md-12">
          <label class="ls-label col-lg-2 col-xlg-1 col-md-3 col-xs-6">
            <b class="ls-label-text">{{ $t('invoices.attributes.id') }}</b>
            <input type="text" @keyup="filterInvoices('search_id', $event)" :maxlength="9" v-model="search_id" :placeholder="$t('invoices.attributes.id')">
          </label>
          <label class="ls-label col-lg-2 col-xlg-1 ol-md-3 col-xs-6">
            <b class="ls-label-text">{{ $t('invoices.attributes.code') }}</b>
            <input type="text" @keyup="filterInvoices('search_code', $event)" v-model="search_code" :placeholder="$t('invoices.attributes.code')">
          </label>
          <label class="ls-label col-lg-2 col-xlg-1 col-md-3 col-xs-12">
            <b class="ls-label-text">{{ $t('invoices.attributes.contract') }}</b>
            <input type="text" @keyup="filterInvoices('search_contract', $event)" v-model="search_contract" :placeholder="$t('invoices.attributes.contract')">
          </label>
          <label class="ls-label col-lg-3 col-xlg-3 col-md-3 col-xs-12">
            <b class="ls-label-text">{{ $t('invoices.attributes.customer') }}</b>
            <input type="text" @keyup="filterInvoices('search_customer_name', $event)" v-model="search_customer_name" :placeholder="$t('invoices.attributes.customer')">
          </label>
          <label class="ls-label col-lg-3 col-xlg-2 col-md-3 col-xs-12">
            <b class="ls-label-text">{{ $t('invoices.filter.contract_code')}}</b>
            <input type="text" @keyup="filterInvoices('search_contract_code', $event)" v-model="search_contract_code" placeholder="Ex.: Abc123">
          </label>
          <label class="ls-label col-lg-3 col-xlg-2 col-md-6 col-xs-12">
            <b class="ls-label-text">{{ $t('invoices.attributes.created_at_initial') }}</b>
            <div class="ls-prefix-group ls-full-width">
              <input v-model="search_created_gt" class="" type="date" @keyup="filterInvoices('search_created_gt', $event)" @change="filterInvoices('search_created_gt', $event)">
            </div>
          </label>
          <label class="ls-label col-lg-3 col-xlg-2 col-md-6 col-xs-12">
            <b class="ls-label-text">{{ $t('invoices.attributes.created_at_end') }}</b>
            <div class="ls-prefix-group ls-full-width">
              <input v-model="search_created_lt" class="" type="date" @keyup="filterInvoices('search_created_lt', $event)" @change="filterInvoices('search_created_lt', $event)">
            </div>
          </label>
          <label class="ls-label col-lg-3 col-md-3 col-xlg-2 col-xs-12">
            <b class="ls-label-text">{{ $t('invoices.attributes.status') }}</b>
            <div class="ls-custom-select">
              <select v-model="search_status" class="ls-select">
                <option value="">{{ $t('application.filter.all') }}</option>
                <option value="1">{{ $t('invoices.attributes.statuses.awaiting_payment') }}</option>
                <option value="2">{{ $t('invoices.attributes.statuses.paid') }}</option>
                <option value="4">{{ $t('invoices.attributes.statuses.canceled') }}</option>
              </select>
            </div>
          </label>
          <label class="ls-label col-lg-3 col-xlg-2 col-md-6 col-xs-12">
            <b class="ls-label-text">{{ $t('invoices.attributes.due_date_initial') }}</b>
            <div class="ls-prefix-group ls-full-width">
              <input v-model="search_due_date_gt" class="" type="date" @keyup="filterInvoices('search_due_date_gt', $event)" @change="filterInvoices('search_due_date_gt', $event)">
            </div>
          </label>
          <label class="ls-label col-lg-3  col-xlg-2 col-md-6 col-xs-12">
            <b class="ls-label-text">{{ $t('invoices.attributes.due_date_end') }}</b>
            <div class="ls-prefix-group ls-full-width">
              <input v-model="search_due_date_lt" class="" type="date" @keyup="filterInvoices('search_due_date_lt', $event)" @change="filterInvoices('search_due_date_lt', $event)">
            </div>
          </label>
          <label class="ls-label col-lg-3 col-xlg-2 col-md-3 col-xs-6">
            <b class="ls-label-text">{{ $t('application.filter.init_value') }}</b>
            <money-input v-model="search_price_gt" :value="search_price_gt" @updateValue="(value) => { this.setFilter('search_price_gt', value) }" :onEnter="updatePriceGT" :callback="updatePriceGT"></money-input>
          </label>
          <label class="ls-label col-lg-3 col-xlg-2 col-md-3 col-xs-6">
            <b class="ls-label-text">{{ $t('application.filter.end_value') }}</b>
            <money-input v-model="search_price_lt" :value="search_price_lt" @updateValue="(value) => {  this.setFilter('search_price_lt', value) }" :onEnter="updatePriceLT" :callback="updatePriceLT"></money-input>
          </label>
          <label class="ls-label col-lg-3 col-xlg-2 col-md-3 col-xs-6">
            <b class="ls-label-text">{{ $t('invoices.attributes.paid_at_initial') }}</b>
            <div class="ls-prefix-group ls-full-width">
              <input type="date" v-model="search_paid_at_gt" @keyup="filterInvoices('search_paid_at_gt', $event)" @change="filterInvoices('search_paid_at_gt', $event)">
            </div>
          </label>
          <label class="ls-label col-lg-3 col-xlg-2 col-md-3 col-xs-6">
            <b class="ls-label-text">{{ $t('invoices.attributes.paid_at_end') }}</b>
            <div class="ls-prefix-group ls-full-width">
              <input type="date" v-model="search_paid_at_lt" @keyup="filterInvoices('search_paid_at_lt', $event)" @change="filterInvoices('search_paid_at_lt', $event)">
            </div>
          </label>
          <div class="btn-action">
            <button type="button" class="ls-btn-danger ls-no-margin-bottom" @click="clearFilters" @keyup.enter="clearFilters">
              <i class="fa fa-eraser" aria-hidden="true"></i>
              <span>{{ $t('application.filter.clear_filters') }}</span>
            </button>
            <button type="button" class="ls-btn ls-no-margin-bottom" v-on:click="searchInvoices">
              <i class="fa fa-search" aria-hidden="true"></i>
              <span>{{ $t('application.filter.filter') }}</span>
            </button>
          </div>
        </div>
      </fieldset>
    </form>
    <div class="column is-5">
    </div>
  </div>
</template>
<script>
  import { setFilterInvoice, clearFilterInvoice } from 'src/app/pages/invoices/vuex/mutations-types'
  import { setPagination } from 'src/app/components/shareds/pagination/vuex/mutations-types'
  import MoneyInput from 'src/app/components/shareds/money-input/MoneyInput'

  export default {
    data () {
      return {
        search_id: '',
        search_code: '',
        search_contract: '',
        search_contract_code: '',
        search_customer_name: '',
        search_status: '',
        search_price_lt: '',
        search_price_gt: '',
        search_created_gt: '',
        search_created_lt: '',
        search_due_date_gt: '',
        search_due_date_lt: '',
        search_paid_at_gt: '',
        search_paid_at_lt: ''
      }
    },
    mounted () {
      this.populateData()
      this.$parent.$on('clearFilters', this.clearFilters)
      this.$watch('search_status', function (val) {
        this.filterInvoices('search_status')
      })
    },
    components: {
      MoneyInput
    },
    methods: {
      searchInvoices () {
        this.$store.commit(setPagination, { per_page: 10, current_page: 1 })
        this.$parent.getInvoices()
      },
      filterInvoices (key, e) {
        this.updateFilter(key, this[key])
        if (e && e.key === 'Enter') {
          this.searchInvoices()
        }
      },
      setFilter (attribute, value) {
        if (value <= 0) return
        this[attribute] = value
        this.updateFilter(attribute, value)
      },
      updatePriceLT (event) {
        this.filterInvoices('search_price_lt', event)
      },
      updatePriceGT (event) {
        this.filterInvoices('search_price_gt', event)
      },
      updateFilter (key, value) {
        key = this.findKey(key)
        if (value !== '' && value !== 'NaN') {
          this.$store.commit(setFilterInvoice, { key: key, value: value })
        } else {
          this.$store.commit(clearFilterInvoice, key)
        }
      },
      populateData () {
        this.search_id = this.$route.query['invoice[id]']
        this.search_code = this.$route.query['invoice[code]']
        this.search_contract = this.$route.query['contract_id']
        this.search_contract_code = this.$route.query['invoice[contract][code]']
        this.search_customer_name = this.$route.query['invoice[customer][customer_name]']
        this.search_status = this.$route.query['invoice[status]']
        this.search_price_lt = this.$route.query['invoice[price_lt]']
        this.search_price_gt = this.$route.query['invoice[price_gt]']
        this.search_created_gt = this.$route.query['invoice[created_at_gt]']
        this.search_created_lt = this.$route.query['invoice[created_at_lt]']
        this.search_due_date_gt = this.$route.query['invoice[due_date_gt]']
        this.search_due_date_lt = this.$route.query['invoice[due_date_lt]']
        this.search_paid_at_gt = this.$route.query['invoice[paid_at_gt]']
        this.search_paid_at_lt = this.$route.query['invoice[paid_at_lt]']
      },
      findKey (key) {
        switch (key) {
          case 'search_id': return 'invoice[id]'
          case 'search_code': return 'invoice[code]'
          case 'search_contract': return 'invoice[contract][id]'
          case 'search_contract_code': return 'invoice[contract][code]'
          case 'search_customer_name': return 'invoice[customer][customer_name]'
          case 'search_status': return 'invoice[status]'
          case 'search_price_lt': return 'invoice[price_lt]'
          case 'search_price_gt': return 'invoice[price_gt]'
          case 'search_created_gt': return 'invoice[created_at_gt]'
          case 'search_created_lt': return 'invoice[created_at_lt]'
          case 'search_due_date_gt': return 'invoice[due_date_gt]'
          case 'search_due_date_lt': return 'invoice[due_date_lt]'
          case 'search_paid_at_gt': return 'invoice[paid_at_gt]'
          case 'search_paid_at_lt': return 'invoice[paid_at_lt]'
        }
      },
      clearFilters () {
        var allAttributes = this.attributes()
        for (var i in allAttributes) {
          this.updateFilter(allAttributes[i], '')
          this[allAttributes[i]] = ''
        }
        this.search_price_gt = 0
        this.search_price_lt = 0
        this.searchInvoices()
      },
      attributes () {
        return ['search_id', 'search_code', 'search_contract', 'search_contract_code', 'search_customer_name', 'search_status', 'search_price_lt',
          'search_price_gt', 'search_created_gt', 'search_created_lt', 'search_due_date_gt', 'search_due_date_lt', 'search_paid_at_gt',
          'search_paid_at_lt']
      }
    }
  }
</script>
<style scoped>
  label.ls-label-text span {
    position: relative;
    top: -12px;
    left: 5px;
  }
  .ls-prefix-group {
    height: 35px;
  }
</style>



// WEBPACK FOOTER //
// Filter.vue?11b2a31a